import LottiePlayer from "./LottiePlayer";

export default LottiePlayer;
